module.exports = __webpack_public_path__ + "static/depoimento 5-d516e2810ab2e8ac45fc2649377884a9.svg";